import { Helmet } from 'react-helmet-async';

const UnderConstructionSection = ({ sectionName }) => (
  <>
    <Helmet>
      <title>{sectionName} en Desarrollo - Germán Hernández Mairal</title>
      <meta
        name="description"
        content={`La sección ${sectionName} está en desarrollo. Próximamente estará disponible con contenido nuevo y actualizado.`}
      />
      <meta
        name="keywords"
        content={`${sectionName}, en desarrollo, Germán Hernández, próximamente, portafolio, servicios`}
      />
      <meta name="author" content="Germán Hernández Mairal" />
    </Helmet>
  <section className="flex flex-col justify-center items-center min-h-[80vh] bg-blue-100 p-8 text-center -mb-16">
    <div className="max-w-[90%] mx-auto">
      {/* Título principal */}
      <h2 className="text-[2.5rem] font-montserrat mb-8
                    xs:text-[1.5rem] sm:text-[2rem] md:text-[2.3rem] lg:text-[2.8rem] xl:text-[3rem]">
        {sectionName} en <span className="bg-custom-orange text-white px-1 text-shadow-custom-dark-blue">Desarrollo</span>
      </h2>

      {/* Texto 1 */}
      <p className="text-[1.5rem] font-montserrat mb-10
                    xs:text-[1rem] sm:text-[1.2rem] md:text-[1.4rem] lg:text-[1.6rem] xl:text-[1.8rem]">
        Esta sección está <span className="relative inline-block text-[#003366] before:absolute before:left-0 before:bottom-[2px] before:w-full before:h-[2px] before:bg-[#ffc107]">en desarrollo</span>, pero <span className="relative inline-block text-[#003366] before:absolute before:left-0 before:bottom-[2px] before:w-full before:h-[2px] before:bg-[#ffc107]">pronto</span> tendrás acceso a contenido nuevo. ¡Mantente atento!
      </p>

      {/* Texto 2 */}
      <p className="text-[1.2rem] font-montserrat mb-12
                    xs:text-[0.9rem] sm:text-[1rem] md:text-[1.1rem] lg:text-[1.3rem] xl:text-[1.4rem]">
        Estoy trabajando para traerte los <span className="bg-custom-orange text-white px-1 text-shadow-custom-dark-blue">mejores servicios</span> y mostrarte un <span className="bg-custom-orange text-white px-1 text-shadow-custom-dark-blue">portafolio lleno de proyectos únicos</span>. ¡Pronto disponible!
      </p>

      {/* Imagen comentada en caso de ser usada */}
      {/*<img
        src="/imgs/under-construction.png"
        alt="Sección en desarrollo"
        className="w-[60%] md:w-[40%] lg:w-[30%] xl:w-[25%] mx-auto mb-8"
      />*/}

      {/* Texto 3 */}
      <p className="text-[1rem] font-montserrat
                    xs:text-[0.8rem] sm:text-[0.9rem] md:text-[1rem] lg:text-[1.1rem] xl:text-[1.2rem]">
        Mientras tanto, puedes <span className="relative inline-block text-[#003366] before:absolute before:left-0 before:bottom-[2px] before:w-full before:h-[2px] before:bg-[#ffc107]">explorar</span> otras secciones del sitio o <span className="relative inline-block text-[#003366] before:absolute before:left-0 before:bottom-[2px] before:w-full before:h-[2px] before:bg-[#ffc107]">contactarme</span> para obtener más información.
      </p>
    </div>
  </section>
  </>
);

export default UnderConstructionSection;